import { QueryClient } from "@tanstack/react-query";

/**
 * Creates a QueryClient with the shared default options used across all apps
 * (app, www, admin). Centralizing this avoids config drift between apps.
 *
 * - staleTime 5m / gcTime 10m
 * - no retry on 4xx client errors, up to 3 retries otherwise
 * - exponential backoff capped at 30s
 */
export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5,
        gcTime: 1000 * 60 * 10,
        retry: (failureCount, error) => {
          if (error && typeof error === "object" && "status" in error) {
            const status = (error as { status: number }).status;
            if (status >= 400 && status < 500) return false;
          }
          return failureCount < 3;
        },
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      },
    },
  });
